import { Pause, Play, Square } from 'lucide-react';
import { useEffect, useState } from 'react';
import { formatClock } from '../lib/recording';
import { useStore } from '../lib/store';
import type { MeetingSession } from '../meeting/MeetingSession';

/** While you record: time recorded, pause/resume and stop (the file goes to Downloads). */
export function RecordingBar({ session }: { session: MeetingSession }) {
  const recording = useStore(session.store, (s) => s.recording);
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!recording) return;
    const t = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, [recording]);
  if (!recording) return null;
  const paused = recording === 'paused';

  return (
    <div className="recording-bar" role="toolbar" aria-label="Grabación">
      <span className={`rec-status ${paused ? 'paused' : ''}`} role="status">
        <span className="rec-dot" aria-hidden />
        {paused ? 'Grabación en pausa' : 'Grabando'} <span className="rec-time">{formatClock(session.recordingElapsedMs())}</span>
      </span>
      <button type="button" className="share-bar-btn" onClick={() => (paused ? session.resumeRecording() : session.pauseRecording())}>
        {paused ? <Play size={15} /> : <Pause size={15} />}
        {paused ? 'Reanudar grabación' : 'Pausar grabación'}
      </button>
      <button type="button" className="share-bar-btn stop" onClick={() => void session.stopRecording()}>
        <Square size={13} fill="currentColor" /> Detener grabación
      </button>
    </div>
  );
}
